import { ReactNode, useEffect } from "react";
import { PopupContainer, PopupContainerStylingProps } from "../PopupContainer/PopupContainer";
import styles from "./RightFullHeight.module.css";

type RightFullHeightPopUpProps = {
  children: ReactNode;
  className?: string;
  id?: string;
};

export const RightFullHeightPopUp = (props: RightFullHeightPopUpProps) => {
  useEffect(() => {
    setTimeout(() => {
      (document.getElementById(styles.rightFullHeightPopUp) as HTMLDivElement).style.width = "25vw";

      if (document.getElementsByClassName("easeOut")) {
        let elements = document.getElementsByClassName("ease-out") as HTMLCollectionOf<HTMLDivElement>;
        for (let element of elements) {
          element.style.width = "25vw";
        }
      }
    }, 0);
  }, []);

  return (
    <div id={styles.rightFullHeightPopUp} className={"pop-up-box ease-out " + (props.className ?? "")}>
      {props.children}
    </div>
  );
};

export type NewRightFullHeightPopupProps = Readonly<{
  id: string;
  children: ReactNode;
  className?: string;
  style?: PopupContainerStylingProps;
  // @todo Add animation.
}>;

export const NewRightFullHeightPopup = ({ id, children, style, className }: NewRightFullHeightPopupProps) => {
  return (
    <PopupContainer {...style} id={id}>
      <div className={className} id={styles.newRightFullHeightPopUp}>
        {children}
      </div>
    </PopupContainer>
  );
};
